// Mesmo cookie do v1 (componentes/cookieConsent.js): quem respondeu numa tela v1 ou num hotsite não vê o aviso de novo.
const _nome = 'empregare_cookie_consent';
const _dias = 365;

// Compartilhado entre os endereços do empregare.com (www, hotsites, homolog). Em outro host (túnel do homolog, *.azurewebsites.net, domínio .com.br) os dois últimos
// rótulos são sufixo público: o navegador recusava o cookie e o aviso voltava em toda tela.
function _dominio() {
    return /(^|\.)empregare\.com$/i.test(window.location.hostname) ? ';domain=.empregare.com' : '';
}

function _ler() {
    const m = document.cookie.match(new RegExp('(?:^|; )' + _nome + '=([^;]*)'));
    if (!m) {
        return null;
    }
    try {
        return JSON.parse(decodeURIComponent(m[1]));
    } catch {
        return null;
    }
}

function _salvar({ f, a, m }) {
    const expira = new Date();
    expira.setDate(expira.getDate() + _dias);
    document.cookie = `${_nome}=${encodeURIComponent(JSON.stringify({ v: 1, f, a, m }))};expires=${expira.toUTCString()};path=/${_dominio()};SameSite=Lax`;
}

export function iniciarConsentimento() {
    const banner = document.getElementById('v2-cookie-banner');
    const janela = document.getElementById('v2-cookie-dlg');
    if (!banner || !janela) {
        return;
    }

    const fecharBanner = () => banner.hidden = true;
    const marcar = (prefs) => {
        document.getElementById('v2-ck-f').checked = !!prefs.f;
        document.getElementById('v2-ck-a').checked = !!prefs.a;
        document.getElementById('v2-ck-m').checked = !!prefs.m;
    };
    const decidir = (prefs) => {
        _salvar(prefs);
        fecharBanner();
        if (janela.open) {
            janela.close();
        }
    };
    const abrir = () => {
        marcar(_ler() || { f: false, a: false, m: false });
        janela.showModal();
    };

    // Nos dois sentidos: a página pré-renderizada (app Android) pode ter revelado o aviso antes de a pessoa aceitar em outra tela.
    banner.hidden = _ler() !== null;

    document.addEventListener('click', e => {
        const alvo = e.target.closest('[data-cookie]');
        if (!alvo) {
            return;
        }
        const acao = alvo.dataset.cookie;
        if (acao === 'aceitar') {
            decidir({ f: true, a: true, m: true });
        } else if (acao === 'recusar') {
            decidir({ f: false, a: false, m: false });
        } else if (acao === 'configurar') {
            abrir();
        } else if (acao === 'salvar') {
            decidir({
                f: document.getElementById('v2-ck-f').checked,
                a: document.getElementById('v2-ck-a').checked,
                m: document.getElementById('v2-ck-m').checked
            });
        } else if (acao === 'fechar') {
            janela.close();
        }
    });
}
